import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../Shared/AdminLayout';
import ProfileCard from '../../Shared/ProfileCard';
import TextInput from '../../Shared/TextInput';
import LoadingButton from '../../Shared/LoadingButton';
import * as moment from 'moment';

const Home = () => {
     const { auth, data, errors } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          date_start: data.date.start || '',
          date_end: data.date.end || '',
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('admin.home.filter'), values, {preserveState:false}).then(() => {
               setSending(false);
          });
     }

     return (
          <div>
               <Helmet>
                    <title>Dashboard</title>
               </Helmet>

               <h2 className="mb-2 w-full text-md text-gray-600 font-semibold">
                    Dashboard
                    <span className="text-sm font-normal italic">
                         {(values.date_start && !values.date_end)?` From ${moment(values.date_start).format('DD MMM YYYY')} to Today ${moment(data.today).format('DD MMM YYYY')}`:''}
                         {(values.date_start && values.date_end)?` From ${moment(values.date_start).format('DD MMM YYYY')} to ${moment(values.date_end).format('DD MMM YYYY')}`:''}
                         {(!values.date_start && !values.date_end)?` Today ${moment(data.today).format('DD MMM YYYY')}`:''}
                    </span>
               </h2>

               <ProfileCard>
                    <div className="col-span-12 bg-white p-2 rounded">
                         <form className="w-full" onSubmit={handleSubmit}>
                              <div className="grid grid-cols-4 gap-2">
                                   <TextInput
                                        className="form-input rounded-md shadow-sm block"
                                        label="Date From"
                                        name="date_start"
                                        type="date"
                                        disable={false}
                                        readonly={false}
                                        must={false}
                                        errors={errors.date_start}
                                        value={values.date_start}
                                        onChange={handleChange}
                                   />
                                   <TextInput
                                        className="form-input rounded-md shadow-sm block"
                                        label="Date To"
                                        name="date_end"
                                        type="date"
                                        disable={false}
                                        readonly={false}
                                        must={false}
                                        errors={errors.date_end}
                                        value={values.date_end}
                                        onChange={handleChange}
                                   />
                                   <div className="inline-block relative">
                                        <LoadingButton type="submit" loading={sending} className="w-full mt-5 text-center items-center px-4 py-3 bg-gray-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring-gray disabled:opacity-25 transition ease-in-out duration-150">
                                             Filter
                                        </LoadingButton>
                                   </div>
                                   <div className="block text-center justify-center items-center">
                                        <InertiaLink className="mt-10" href={route('admin.home')}>Clear</InertiaLink>
                                   </div>
                              </div>
                         </form>
                    </div>
                    <div className="col-span-12 grid grid-cols-3 gap-6">
                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Global</h2>
                              <p className="mt-1 text-sm text-gray-600">
                                   Total Visits
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.total_visits}
                                   </span>
                              </p>
                              <p className="mt-1 text-sm text-gray-600">
                                   Unique Users
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.visitors.unique}
                                   </span>
                              </p>
                              <p className="mt-1 text-sm text-gray-600">
                                   Returning Users
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.visitors.returning}
                                   </span>
                              </p>
                         </div>
                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Cart</h2>
                              <p className="mt-1 text-sm text-gray-600">
                                   Total Created
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.cart.total}
                                   </span>
                              </p>
                              <p className="mt-1 text-sm text-gray-600">
                                   Total Purchased
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.cart.purchase}
                                   </span>
                              </p>
                              <p className="mt-1 text-sm text-gray-600">
                                   Total Estimate Sent
                                   <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                        {data.dashboard.cart.estimate}
                                   </span>
                              </p>
                         </div>
                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Top Country Visits</h2>
                              {data.dashboard.top.country.map((peyi, i) => {
                                   return <p key={`coun${i}`} className="mt-1 text-sm text-gray-600">
                                        {peyi.country}
                                        <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                             {peyi.visits}
                                        </span>
                                   </p>
                              })}
                         </div>
                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Top Citiy Visits</h2>
                              {data.dashboard.top.city.map((vil, i) => {
                                   return <p key={`city${i}`} className="mt-1 text-sm text-gray-600">
                                        {vil.city}
                                        <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                             {vil.visits}
                                        </span>
                                   </p>
                              })}
                         </div>
                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Top Pages Visits</h2>
                              {data.dashboard.page_word.most_page.map((page, i) => {
                                   return <p key={`page${i}`} className="mt-1 text-sm text-gray-600 border-b border-b-gray-200">
                                        {page.page}
                                        <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                             {page.visits}
                                        </span>
                                   </p>
                              })}
                         </div>

                         <div className="space-y-2 p-2 border border-gray-100 bg-white rounded">
                              <h2 className="text-md text-slate-600 border-b font-semibold">Top Words Searched</h2>
                              {data.dashboard.page_word.most_word.map((word, i) => {
                                   return <p key={`mo${i}`} className="mt-1 text-sm text-gray-600 border-b border-b-gray-200">
                                        {word.word}
                                        <span className={`float-right px-2 rounded font-bold text-gray-600`}>
                                             {word.visits}
                                        </span>
                                   </p>
                              })}
                         </div>
                    </div>
               </ProfileCard>
          </div>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Home.layout = page => <AdminLayout children={page} header={'Dashboard'} />;

export default Home;
